import { ReactNode } from 'react';
import { useEffectiveChildMode } from '@/components/utils/useEffectiveChildMode';

type ChildRouteSwitchProps = {
  /** Renderas i barnläge (effectiveChildMode = true). */
  child: ReactNode;
  /** Renderas i vuxen-/handledarläge. */
  adult: ReactNode;
};

/**
 * Växlar mellan barn- och vuxenvy per route. Gaten sker i KOMPONENTEN via
 * useEffectiveChildMode (invariant: inget barn-läckage, aldrig modul-konstant).
 * Samma URL ger alltså olika vy beroende på läge — routes förblir desamma.
 */
const ChildRouteSwitch = ({ child, adult }: ChildRouteSwitchProps) => {
  const effectiveChildMode = useEffectiveChildMode();
  return <>{effectiveChildMode ? child : adult}</>;
};

export default ChildRouteSwitch;
